var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransfereeRequestIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5903,
    cy: 17.7427,
    r: 17.5278,
    fill: "#4339F2",
    fillOpacity: 0.22
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 27V25C23 23.9391 22.5786 22.9217 21.8284 22.1716C21.0783 21.4214 20.0609 21 19 21H12C10.9391 21 9.92172 21.4214 9.17157 22.1716C8.42143 22.9217 8 23.9391 8 25V27",
    stroke: "#4339F2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 17C17.7091 17 19.5 15.2091 19.5 13C19.5 10.7909 17.7091 9 15.5 9C13.2909 9 11.5 10.7909 11.5 13C11.5 15.2091 13.2909 17 15.5 17Z",
    stroke: "#4339F2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14V20",
    stroke: "#4339F2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30 17H24",
    stroke: "#4339F2",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfereeRequestIcon);
export default __webpack_public_path__ + "static/media/transfereeRequestIcon.698779f111dad7c000f98057061ce2d7.svg";
export { ForwardRef as ReactComponent };